<script setup lang="ts">
import { computed } from 'vue'

import { Figure, Image, ImageSrcSet, Picture, Badge, StarRating } from '@toni/brand-ui'
import { BauerProductCard, PurchaseOptions } from '@toni/commerce-api-types'

import PurchaseOption from '../PurchaseOption.vue'

const props = defineProps<{
  productCard: BauerProductCard,
  purchaseOptions: PurchaseOptions
}>()
const purchaseOptions = computed(() => props.purchaseOptions || [])
const primaryPurchaseOption = purchaseOptions.value[0]

const overallRating = computed(() => {
  return props.productCard.ratings?.find((rating) => rating.type === 'overall' && rating.value > 0)
})
</script>

<template>
  <div class="h-full flex flex-col gap-2">
    <div class="flex flex-col gap-2 items-center flex-1 justify-between">
      <div class="min-h-[1.375rem] sm:min-h-[1.625rem] w-full">
        <Badge v-if="productCard.label"
               type="text"
               variant="ghost"
               class="bg-aside text-center tracking-wide leading-[1.375rem] sm:leading-[1.625rem] font-medium w-full line-clamp-1 py-0 px-2 text-[0.6875rem] sm:text-[1rem]">
          {{ productCard.label }}
        </Badge>
      </div>
      <h3 class="font-heading font-medium text-center leading-snug text-[0.875rem] sm:text-heading-xs text-foreground line-clamp-2 min-h-10 sm:min-h-15 sm:line-clamp-3 sm:min-h-[4.125rem]">
        {{ productCard?.title }}
      </h3>
      <div class="flex min-h-[1.625rem]">
        <StarRating v-if="overallRating"
                    :value="overallRating.value"
                    :total="overallRating.maxValue"
                    size="sm"
                    :minimum-fraction-digits="1"
                    :maximum-fraction-digits="1" />
      </div>
      <Image v-if="productCard?.images?.[0]">
        <Figure class="flex flex-1 mb-2">
          <Picture class="flex-1 flex items-center justify-center w-[6.5rem] h-[6.5rem] sm:w-[7.5rem] sm:h-[7.5rem]">
            <ImageSrcSet>
              <img :src="productCard?.images?.[0]?.url"
                   :alt="productCard?.images?.[0]?.altText"
                   class="max-w-[6.5rem] max-h-[6.5rem] sm:max-w-[7.5rem] sm:max-h-[7.5rem]">
            </ImageSrcSet>
          </Picture>
        </Figure>
      </Image>
      <PurchaseOption v-if="primaryPurchaseOption"
                      :purchase-option="primaryPurchaseOption"
                      size="md"
                      variant="highlighted"
                      :is-comparison="true"
                      type="icon-only" />
    </div>
  </div>
</template>
